export const BRAZILIAN_STATES = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
];

export interface InstallationProfileOption {
  value: string;
  label: string;
}

export const INSTALLATION_PROFILES: InstallationProfileOption[] = [
  { value: 'COMMERCIAL_SIMPLE', label: 'Comercial simples' },
  { value: 'RETAIL', label: 'Mercado / varejo' },
  { value: 'RETAIL_REFRIGERATION', label: 'Mercado com refrigeração relevante' },
  { value: 'LARGE_RETAIL_SUPERMARKET', label: 'Atacarejo / supermercado grande' },
  { value: 'LIGHT_INDUSTRY', label: 'Indústria leve' },
  { value: 'MEDIUM_HEAVY_INDUSTRY', label: 'Indústria média / pesada' },
];

export function getInstallationProfileLabel(value?: string): string {
  if (!value) return 'Comercial simples';
  const found = INSTALLATION_PROFILES.find((p) => p.value === value);
  return found ? found.label : value;
}
